export default __webpack_public_path__ + "static/media/WordSearch_img.a2d01e85.png";